// extracted by mini-css-extract-plugin
export default {"IssueSidePanelContent":"IssueSidePanel-module__IssueSidePanelContent--Jw4UY"};